<template>
  <v-container>
    <!--   
    <v-card style="padding: 40px" class="mr-2 ml-2">{{item}}
      <v-card-text>{{item.pregunta}}</v-card-text>
            <v-card-text>a) {{item.respuestas[0].respuesta}}</v-card-text>
            <v-card-text>b) {{item.respuestas[1].respuesta}}</v-card-text>
            <v-card-text>c) {{item.respuestas[2].respuesta}}</v-card-text>
            <v-card-text>d) {{item.respuestas[3].respuesta}}</v-card-text> -->

    <br />
    <v-card
      class="mx-auto"
      max-width="auto"
      v-if="questionIndex < preguntas.length"
      v-bind:key="questionIndex"
    >
      <!-- <v-card-text v-if="this.testSelected != null"
        >{{
          "Tema " +
            temas.find((tema) => tema.numeroTema === selected.numeroTema)
              .numeroTema +
            ": " +
            temas.find((tema) => tema.numeroTema === selected.numeroTema)
              .nombreTema
        }}
      </v-card-text>
      <v-card-subtitle v-if="this.testSelected != null"
        >{{
          tests.find(
            (test) => test.numeroTest == preguntas[questionIndex].numeroTest
          ).numeroTest +
            ". " +
            tests.find(
              (test) => test.numeroTest == preguntas[questionIndex].numeroTest
            ).nombreTest
        }}
      </v-card-subtitle>
      <v-card-text v-if="this.temaSelected != null">{{
        "Tema " +
          temas.find((tema) => tema.numeroTema === selected.numeroTema)
            .numeroTema +
          ": " +
          this.selected.nombreTema
      }}</v-card-text>
      <v-card-text
        v-if="this.temasSelected.length > 0 || this.testsSelected.length > 0"
        >{{
          "Tema " +
            temas.find(
              (tema) => tema.numeroTema === preguntas[questionIndex].numeroTema
            ).numeroTema +
            ": " +
            temas.find(
              (tema) => tema.numeroTema === preguntas[questionIndex].numeroTema
            ).nombreTema
        }}</v-card-text
      >
      <v-card-subtitle
        v-if="this.temasSelected.length > 0 || this.testsSelected.length > 0"
        >{{
          "Test " +
            tests.find(
              (test) => test.numeroTest == preguntas[questionIndex].numeroTest
            ).numeroTest +
            ": " +
            tests.find(
              (test) => test.numeroTest == preguntas[questionIndex].numeroTest
            ).nombreTest
        }}</v-card-subtitle
      > -->

      <!--v-card-title v-if="this.temasSelected.length > 0">{{
        "Temas " + this.temasSelected + ": " 
      }}</v-card-title-->
      <!--v-card-subtitle  v-for="(item, indexTest) in testsSelected"
                    :key="indexTest">{{
        "Tema: " + item.split(",")[1] + " , test nº " + item.split(",")[0] 
      }}</v-card-subtitle-->
      <!-- <v-progress-linear
        v-if="true"
        :value="((questionIndex + 1) / preguntas.length) * 100"
        max="100"
        color="green"
        absolute
        height="7"
      ></v-progress-linear> -->

      <!-- <v-card-subtitle class="layout justify-center">{{
        questionIndex + 1 + "/" + preguntas.length
      }}</v-card-subtitle> -->

      <v-carousel
        class="justify-center"
        height="100%"
        hide-delimiters
        progress
        progress-color="green"
        :show-arrows="false"
        :continuous="false"
        v-model="questionIndex"
        @change="change"
        :touchless="pause"
      >
        <v-carousel-item
          v-for="(item, questionIndex) in preguntas"
          :key="questionIndex"
          height="100%"
          width="100%"
        >
          <v-card color="grey lighten-2">
            <v-card-text class="black--text layout text-justify pb-0">
              <vue-markdown>{{
                preguntas[questionIndex].pregunta
              }}</vue-markdown>
            </v-card-text>
            <v-dialog v-model="report" max-width="auto">
              <template v-slot:activator="{ on }">
                <div
                  class="caption ml-2 mr-4 pb-0 text-end font-weight-thin"
                  style="cursor: pointer"
                  v-on="on"
                >
                  Impugnar pregunta <v-icon>mdi-alert </v-icon>
                </div>
              </template>
              <v-card v-click-outside="onClickOutside">
                <v-card-text>
                  <v-textarea
                    v-model="textoReporte"
                    label="Indicar el motivo de la reclamación:"
                  >
                  </v-textarea>

                  <v-btn @click="enviarReport()"> Enviar </v-btn>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-card-subtitle style="font-size: 0.7em" class="pb-0">
              <vue-markdown
                >{{ "Tema: **" + preguntas[questionIndex].nombreTema + "**" }}
                {{
                  "Test: **" + preguntas[questionIndex].nombreTest + "**"
                }}</vue-markdown
              >
            </v-card-subtitle>
          </v-card>

          <v-spacer></v-spacer>
          <v-expansion-panels
            v-model="model"
            :readonly="read"
            color="primary"
            class="mb-2"
          >
            <!-- v-expansion-panel color="secondary" @click="selectOption(0)">
          <v-expansion-panel-header disable-icon-rotate>
            <template v-slot:actions>
              <v-icon color="teal">{{
                i == 1 ? "mdi-check-bold" : "mdi-pencil"
              }}</v-icon> </template
            >Item</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-divider></v-divider>
            <v-card-text v-text="preguntas[questionIndex].respuestas[0].respuestaCorrecta"></v-card-text>
          </v-expansion-panel-content>
        </v-expansion-panel -->

            <v-expansion-panel
              @click="selectOption(0)"
              :style="
                userResponses[questionIndex] == 0
                  ? 'background:#efefef;color:black'
                  : ''
              "
            >
              <v-expansion-panel-header disable-icon-rotate>
                <template v-slot:actions>
                  <v-icon
                    :color="
                      !mostrarRespuestas
                        ? 'teal'
                        : isCorrect(0) && mostrarRespuestas
                        ? 'teal'
                        : preguntas[questionIndex].respuestas[0].correcta &&
                          mostrarRespuestas
                        ? 'teal'
                        : 'error'
                    "
                    >{{
                      isCorrect(0) && mostrarRespuestas
                        ? "mdi-check-bold"
                        : userResponses[questionIndex] == 0 && mostrarRespuestas
                        ? "mdi-close-circle"
                        : preguntas[questionIndex].respuestas[0].correcta &&
                          mostrarRespuestas
                        ? "mdi-check-bold"
                        : userResponses[questionIndex] == 0
                        ? "mdi-check-bold"
                        : ""
                    }}</v-icon
                  >
                </template>

                <v-row justify="start" align="center" no-gutters>
                  <v-col cols="12">
                    <vue-markdown>{{
                      "a)" + preguntas[questionIndex].respuestas[0].respuesta
                    }}</vue-markdown>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <!-- <v-row
                v-if="
                  mostrarRespuestas && preguntas[questionIndex].respuestas[0].correcta
                "
              >
                <v-col>
                  {{ preguntas[questionIndex].explicacion }}
                </v-col>
              </v-row> -->
              <!-- <v-expansion-panel-content
                v-if="preguntas[questionIndex].respuestas[0].correcta"
              >
                <v-divider></v-divider>
                <v-card-text>{{
                  preguntas[questionIndex].explicacion
                }}</v-card-text>
              </v-expansion-panel-content> -->
            </v-expansion-panel>

            <v-expansion-panel
              @click="selectOption(1)"
              :style="
                userResponses[questionIndex] == 1
                  ? 'background:#efefef;color:black'
                  : ''
              "
            >
              <v-expansion-panel-header disable-icon-rotate>
                <template v-slot:actions>
                  <v-icon
                    :color="
                      !mostrarRespuestas
                        ? 'teal'
                        : isCorrect(1) && mostrarRespuestas
                        ? 'teal'
                        : preguntas[questionIndex].respuestas[1].correcta &&
                          mostrarRespuestas
                        ? 'teal'
                        : 'error'
                    "
                    >{{
                      isCorrect(1) && mostrarRespuestas
                        ? "mdi-check-bold"
                        : userResponses[questionIndex] == 1 && mostrarRespuestas
                        ? "mdi-close-circle"
                        : preguntas[questionIndex].respuestas[1].correcta &&
                          mostrarRespuestas
                        ? "mdi-check-bold"
                        : userResponses[questionIndex] == 1
                        ? "mdi-check-bold"
                        : ""
                    }}</v-icon
                  >
                </template>
                <v-row justify="start" align="center" no-gutters>
                  <v-col>
                    <vue-markdown>{{
                      "b)" + preguntas[questionIndex].respuestas[1].respuesta
                    }}</vue-markdown>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <!-- <v-row
                v-if="
                  mostrarRespuestas && preguntas[questionIndex].respuestas[1].correcta
                "
              >
                <v-col>
                  {{ preguntas[questionIndex].explicacion }}
                </v-col>
              </v-row> -->
              <!-- 
              <v-expansion-panel-content
                v-if="preguntas[questionIndex].respuestas[1].correcta"
              >
                <v-divider></v-divider>
                <v-card-text>{{
                  preguntas[questionIndex].explicacion
                }}</v-card-text>
              </v-expansion-panel-content> -->
            </v-expansion-panel>

            <v-expansion-panel
              @click="selectOption(2)"
              :style="
                userResponses[questionIndex] == 2
                  ? 'background:#efefef;color:black'
                  : ''
              "
            >
              <v-expansion-panel-header disable-icon-rotate>
                <template v-slot:actions>
                  <v-icon
                    :color="
                      !mostrarRespuestas
                        ? 'teal'
                        : isCorrect(2) && mostrarRespuestas
                        ? 'teal'
                        : preguntas[questionIndex].respuestas[2].correcta &&
                          mostrarRespuestas
                        ? 'teal'
                        : 'error'
                    "
                    >{{
                      isCorrect(2) && mostrarRespuestas
                        ? "mdi-check-bold"
                        : userResponses[questionIndex] == 2 && mostrarRespuestas
                        ? "mdi-close-circle"
                        : preguntas[questionIndex].respuestas[2].correcta &&
                          mostrarRespuestas
                        ? "mdi-check-bold"
                        : userResponses[questionIndex] == 2
                        ? "mdi-check-bold"
                        : ""
                    }}</v-icon
                  >
                </template>
                <v-row justify="start" align="center" no-gutters>
                  <v-col>
                    <vue-markdown>{{
                      "c)" + preguntas[questionIndex].respuestas[2].respuesta
                    }}</vue-markdown>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <!-- <v-row
                v-if="
                  mostrarRespuestas && preguntas[questionIndex].respuestas[2].correcta
                "
              >
                <v-col>
                  {{ preguntas[questionIndex].explicacion }}
                </v-col>
              </v-row> -->

              <!-- <v-expansion-panel-content
                v-if="preguntas[questionIndex].respuestas[2].correcta"
              >
                <v-divider></v-divider>
                <v-card-text>{{
                  preguntas[questionIndex].explicacion
                }}</v-card-text>
              </v-expansion-panel-content> -->
            </v-expansion-panel>

            <v-expansion-panel
              @click="selectOption(3)"
              :style="
                userResponses[questionIndex] == 3
                  ? 'background:#efefef;color:black'
                  : ''
              "
            >
              <v-expansion-panel-header disable-icon-rotate>
                <template v-slot:actions>
                  <v-icon
                    :color="
                      !mostrarRespuestas
                        ? 'teal'
                        : isCorrect(3) && mostrarRespuestas
                        ? 'teal'
                        : preguntas[questionIndex].respuestas[3].correcta &&
                          mostrarRespuestas
                        ? 'teal'
                        : 'error'
                    "
                    >{{
                      isCorrect(3) && mostrarRespuestas
                        ? "mdi-check-bold"
                        : userResponses[questionIndex] == 3 && mostrarRespuestas
                        ? "mdi-close-circle"
                        : preguntas[questionIndex].respuestas[3].correcta &&
                          mostrarRespuestas
                        ? "mdi-check-bold"
                        : userResponses[questionIndex] == 3
                        ? "mdi-check-bold"
                        : ""
                    }}</v-icon
                  >
                </template>
                <v-row justify="start" align="center" no-gutters>
                  <v-col>
                    <vue-markdown>{{
                      "d)" + preguntas[questionIndex].respuestas[3].respuesta
                    }}</vue-markdown>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <!-- <v-row
                v-if="
                  mostrarRespuestas && preguntas[questionIndex].respuestas[3].correcta
                "
              >
                <v-col>
                  {{ preguntas[questionIndex].explicacion }}
                </v-col>
              </v-row> -->

              <!-- <v-expansion-panel-content
                v-if="preguntas[questionIndex].respuestas[3].correcta"
              >
                <v-divider></v-divider>
                <v-card-text>{{
                  preguntas[questionIndex].explicacion
                }}</v-card-text>
              </v-expansion-panel-content> -->
            </v-expansion-panel>
          </v-expansion-panels>
          <v-card v-if="mostrarRespuestas" class="black--text ml-0 mr-0">
            <v-card-subtitle class="black--text">
              Explicación:
            </v-card-subtitle>
            <v-card-text class="black--text layout text-justify pb-0">
              <vue-markdown>{{
                preguntas[questionIndex].explicacion
              }}</vue-markdown>
            </v-card-text>
          </v-card>
          <v-card-text v-if="!checkErrorsBool" class="text-center"
            >Tiempo: {{ Math.round(timerCount / 60) }}:{{ timerCount % 60 }}
          </v-card-text>
          <!-- v-list>
        <v-list-item-group v-model="model">
          <v-list-item shaped="true">
            <v-list-item-content>
              <v-list-item-title @click="selectOption(0)">
                <v-avatar color="indigo" size="36">
                  <span class="white--text headline">{{ 0 | charIndex }} </span>
                </v-avatar>
                {{ preguntas[questionIndex].respuestas[0].respuesta }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title @click="selectOption(1)"
                >{{ 1 | charIndex }}.
                {{ preguntas[questionIndex].respuestas[1].respuesta }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content @click="selectOption(2)">
              <v-list-item-title
                >{{ 2 | charIndex }}.
                {{ preguntas[questionIndex].respuestas[2].respuesta }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content @click="selectOption(3)">
              <v-list-item-title
                >{{ 3 | charIndex }}.
                {{ preguntas[questionIndex].respuestas[3].respuesta }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list-->
        </v-carousel-item>
      </v-carousel>
      <v-card-actions class="justify-center">
        <!-- <v-btn :disabled="atrasDisabled" color="orange" v-on:click="prev()">
          Atrás
        </v-btn> -->
        <v-spacer></v-spacer>

        <v-pagination
          :color="
            this.userResponses[questionIndex] == null ? 'grey' : '#004100'
          "
          circle
          v-model="paginationIndex"
          @next="next"
          :length="preguntas.length"
          :disabled="pause"
        ></v-pagination>

        <v-spacer></v-spacer>

        <!-- <v-btn
          :color="
            blockTest
              ? 'green'
              : this.userResponses[questionIndex] == null
              ? 'blue'
              : 'green'
          "
          align-end
          v-on:click="next()"
          :disabled="questionIndex >= preguntas.length"
        >
          {{
            blockTest
              ? "Siguiente"
              : userResponses[questionIndex] == null
              ? "Saltar"
              : "Siguiente"
          }}
        </v-btn> -->
      </v-card-actions>
      <v-row class="mx-auto mt-2">
        <v-col class="ml-4" align="left">
          <v-btn
            :color="this.pause ? 'red' : '#004100'"
            dark
            fab
            @click="pause = !pause"
          >
            <v-icon>mdi-pause</v-icon>
          </v-btn>
        </v-col>
        <v-col class="mr-4" align="center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                fab
                @click="save()"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Guardar y continuar más tarde</span>
          </v-tooltip>
        </v-col>
        <!-- <v-col class="ml-4" align="center">
          <v-btn
            :color="this.pause ? 'red' : '#004100'"
            dark
            fab
            @click="pause = !pause"
          >
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </v-col> -->
        <v-col class="mr-4" align="right">
          <v-btn color="#004100" fab dark @click="score2()">
            <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-list v-if="questionIndex < preguntas.length">
      <v-list-group v-model="item.active" :prepend-icon="item.action" no-action>
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="(child, index) in preguntas"
          :key="index"
          style="cursor: pointer; padding-left: 0px"
        >
          <v-list-item-content
            @click="questionIndex = index"
            :style="
              questionIndex == index
                ? 'background-color: lightgray; border-radius: 20px; padding-left: 10px'
                : ''
            "
          >
            <v-list-item-title>
              <v-avatar
                :style="
                  mostrarRespuestasBis == true
                    ? userResponses[index] != null
                      ? preguntas[index].respuestas[userResponses[index]]
                          .correcta
                        ? 'background-color:#004100; color:white'
                        : 'background-color:red; color:white'
                      : 'background-color:gray; color:white'
                    : userResponses[index] != null
                    ? 'background-color:#004100; color:white'
                    : 'background-color:gray; color:white'
                "
                size="56"
                >{{ index + 1 }}</v-avatar
              >{{ child.pregunta }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <v-card
      class="mx-auto"
      max-width="auto"
      v-if="questionIndex >= preguntas.length"
      v-bind:key="questionIndex"
    >
      <v-card-title>
        {{
          scoreValue / preguntas.length == 1
            ? "¡Excelente!"
            : scoreValue / preguntas.length > 0.85
            ? "¡Muy bien hecho!. Este tema lo llevas muy bien preparado."
            : scoreValue / preguntas.length > 0.7
            ? "Bien hecho, pero seguro que puedes sacar un poco más."
            : scoreValue / preguntas.length >= 0.5
            ? "Apto. Repasa más el tema!"
            : "No apto. Necesitas preparar mejor el tema"
        }}
      </v-card-title>

      <v-spacer></v-spacer>

      <v-row>
        <v-col cols="3" class="ml-2 justify-end">
          <v-progress-circular
            :rotate="270"
            :size="100"
            :width="15"
            :value="scoreFinal"
            color="teal"
          >
            {{ scoreFinal }} / {{ preguntas.length }}
          </v-progress-circular>
        </v-col>
        <v-col>
          <v-card-subtitle class="text-left"
            >Puntuación obtenida</v-card-subtitle
          >
        </v-col>
      </v-row>
      <v-card-subtitle>
        Porcentaje de aciertos
        {{ ((scoreValue / preguntas.length) * 100).toFixed(2) }}%
      </v-card-subtitle>
      <v-card-subtitle>
        <v-icon>mdi-emoticon-happy</v-icon> Preguntas acertadas
        {{ scoreValue }} / {{ preguntas.length }}
      </v-card-subtitle>
      <v-card-subtitle>
        <v-icon>mdi-emoticon-sad</v-icon> Preguntas falladas {{ fails }} /
        {{ preguntas.length }}
      </v-card-subtitle>
      <v-card-subtitle>
        <v-icon>mdi-alarm</v-icon> Preguntas sin contestar {{ blank }} /
        {{ preguntas.length }}
      </v-card-subtitle>
      <v-card-actions class="justify-center">
        <v-btn @click="restart()">
          <v-icon>mdi-restart</v-icon> Reiniciar
        </v-btn>
        <v-btn @click="checkErrors()">
          Ver errores <v-icon>mdi-check</v-icon></v-btn
        >
      </v-card-actions>
    </v-card>
    <!-- <v-card v-if="report == true">
              <v-card-title class="text-h4 font-weight-bold">
                Reportar pregunta
              </v-card-title>

              <v-card-text v-cloak @drop.prevent="addFile" @dragover.prevent>
                <v-container fill-height>
                  <v-row align="center" justify="center">
                    <v-col cols="12" sm="12" md="12">
                      <v-card-subtitle class="text-h5 font-weight-bold">Pregunta: {{ preguntas[questionIndex].pregunta }}</v-card-subtitle>
                    </v-col>
                 
                
                    <v-col class="border" cols="12" sm="12" md="12">
                     
                     <v-card-subtitle class="text-h6">Respuesta A: {{ preguntas[questionIndex].respuestas[0].respuesta }}</v-card-subtitle>
                      <br>
                     <span v-if="preguntas[questionIndex].respuestas[0].correcta" class="text-h8 green--text">Respuesta correcta</span>

                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                     <v-card-subtitle class="text-h6">Respuesta B: {{ preguntas[questionIndex].respuestas[1].respuesta }}</v-card-subtitle>
                     <span v-if="preguntas[questionIndex].respuestas[1].correcta" class="text-h6">Respuesta correcta</span>

                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                     <v-card-subtitle class="text-h6">Respuesta C: {{ preguntas[questionIndex].respuestas[2].respuesta }}</v-card-subtitle>
                     <span v-if="preguntas[questionIndex].respuestas[2].correcta" class="text-h6">Respuesta correcta</span>

                    </v-col>
                     <v-col cols="12" sm="12" md="12">
                     <v-card-subtitle class="text-h6">Respuesta D: {{ preguntas[questionIndex].respuestas[3].respuesta }}</v-card-subtitle>
                     <span v-if="preguntas[questionIndex].respuestas[3].correcta" class="text-h6">Respuesta correcta</span>

                    </v-col>
                     <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      label="Indicar el motivo de la reclamación:">
                    </v-textarea>
                    </v-col>
               
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="blue darken-1" text @click="report=false">Cancel</v-btn>
                <v-btn color="blue darken-1" text >Enviar reporte</v-btn
                >
              </v-card-actions>
            </v-card> -->
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
// import jsPDF from "jspdf";
import { firebase } from "@/firebase";

// import "jspdf-autotable";
import { async } from "q";

import VueMarkdown from "vue-markdown";

export default {
  components: {
    VueMarkdown,
  },
  data: (vm) => ({
    item: {
      action: "mdi-format-list-bulleted-square",
      items: [{ title: "List Item" }],
      title: "Índice",
    },
    checkErrorsBool: false,
    finished: false,
    pause: false,
    report: false,
    textoReporte: "",
    timerCountTemp: 0,
    scoreValue: 0,
    fails: 0,
    blank: 0,
    blockTest: false,
    mostrarRespuestas: false,
    mostrarRespuestasBis: true,
    read: true,
    panel: -1,
    model: -1,
    user: "",
    timerCount: 30,
    userResponses: null,
    questionIndex: 0,
    isActive: false,
    selected: {},
    texto: "",
    menu1: false,
    menu2: false,
    items: ["A", "B", "C", "D"],
    rules: {
      required: (value) => !!value || "Required.",

      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    },

    dialog: false,
    dialogEdit: false,

    editedIndex: -1,
    nuevaPregunta: {
      tema: "",
      numeroPregunta: Number,
      numeroTema: Number,
      pregunta: "",
      respuestaA: "",
      respuestaB: "",
      respuestaC: "",
      respuestaD: "",
      respuestaCorrecta: "",
    },
    preguntaEdited: {
      tema: "",
      numeroPregunta: Number,
      numeroTema: Number,
      pregunta: "",
      respuestaA: "",
      respuestaB: "",
      respuestaC: "",
      respuestaD: "",
      respuestaCorrecta: "",
    },
    editedItem: {
      pregunta: "",
      respuestaA: "",
      respuestaB: "",
      respuestaC: "",
      respuestaD: "",
      respuestaCorrecta: "",
    },
    defaultItem: {
      tema: "",
      numeroPregunta: Number,
      numeroTema: Number,
      pregunta: "",
      respuestaA: "",
      respuestaB: "",
      respuestaC: "",
      respuestaD: "",
      respuestaCorrecta: "",
    },
    atrasDisabled: false,
  }),

  filters: {
    charIndex: function (i) {
      return String.fromCharCode(97 + i);
    },
  },
  async created() {
    await this.initialize();
    window.addEventListener("keydown", (e) => {
      if (e.key == "p" || e.key == "P") {
        this.pause = !this.pause;
      }

      if (this.pause) {
        return;
      }

      if (this.report) {
        return;
      }

      if (e.key == "ArrowLeft") {
        if (this.questionIndex == 0) {
          return;
        }
        this.questionIndex--;
        this.next(this.questionIndex);
      }

      if (e.key == "ArrowRight") {
        if (this.questionIndex == this.preguntas.length) {
          return;
        }
        this.questionIndex++;
        this.next(this.questionIndex);
      }

      if (e.key == "a" || e.key == "A") {
        this.selectOption(0);
      }
      if (e.key == "b" || e.key == "B") {
        this.selectOption(1);
      }
      if (e.key == "c" || e.key == "C") {
        this.selectOption(2);
      }
      if (e.key == "d" || e.key == "D") {
        this.selectOption(3);
      }
    });
  },
  computed: {
    ...mapState(["preguntas", "exist", "temas", "tests", "usuario"]),
    // ...mapGetters(["arrayFiltradoPreguntas"]),
    isDisabled: function () {
      return !this.atrasDisabled;
    },
    formTitle() {
      return this.report === true
        ? "Cancelar reclamación"
        : "Reclamar pregunta";
    },
    paginationIndex: {
      // getter
      get: function () {
        return this.questionIndex + 1;
      },
      // setter
      set: function (newValue) {
        this.questionIndex = newValue - 1;
      },
    },
    scoreFinal() {
      console.log(
        (
          (this.scoreValue - this.fails / 3) *
          (100 / this.preguntas.length)
        ).toFixed(2) < 0
      );
      if (
        (
          (this.scoreValue - this.fails / 3) *
          (100 / this.preguntas.length)
        ).toFixed(2) < 0
      ) {
        console.log("dentro if scorefinal");
        return 0;
      } else {
        return (
          (this.scoreValue - this.fails / 3) *
          (100 / this.preguntas.length)
        ).toFixed(2);
      }
    },
  },
  props: {
    timerCountProp: {
      type: Number,
      default: () => 1800,
    },
    temaSelected: {
      type: Object,
      default: () => {},
    },
    testSelected: {
      type: Object,
      default: () => {},
    },
    testsSelected: {
      type: Array,
      default: () => [],
    },
    temasSelected: {
      type: Array,
      default: () => [],
    },
    numeroPreguntas: {
      type: Number,
      default: () => 50,
    },
    porcentajesSelected: {
      type: Number,
      default: () => 0,
    },
    resume: {
      type: Boolean,
      default: () => false,
    },
    preguntasProps: {
      type: Array,
      default: () => [],
    },
    respuestasProps: {
      type: Array,
      default: () => [],
    },
    questionIndexProps: {
      type: Number,
      default: () => -1,
    },
    idTestIncompleted: {
      type: String,
      default: () => null,
    },
  },
  watch: {
    questionIndex: function () {
      console.log("watch questionIndex");
      if (!this.checkErrorsBool) {
        console.log("this.checkErrorsBool next");
        console.log(this.checkErrorsBool);
        this.blockTest = false;
        this.mostrarRespuestas = false;
        this.read = true;
        this.model = [];
        if (this.userResponses[this.questionIndex] != null) {
          console.log("model antes" + this.model);
          this.mostrarRespuestas = true;
          this.getCorrectAnswer();
          this.blockTest = true;

          console.log("model despues" + this.model);
        } else {
          console.log("else in next antes de model vacio");
          this.model = [];
        }
      } else {
        this.blockTest = true;
        this.mostrarRespuestas = true;
        this.getCorrectAnswer();
      }
      if (
        this.questionIndex == this.preguntas.length &&
        !this.checkErrorsBool
      ) {
        this.score();
      }
    },
    // preguntas: function () {
    //   this.userResponses = Array(this.preguntas.length).fill(null);
    // },
  },
  mounted() {
    window.setInterval(() => {
      if (this.timerCount != 0) {
        if (this.report != true && this.pause != true) {
          this.timerCount--;
        }
      } else {
        this.blockTest = true;
      }
    }, 1000);
  },
  methods: {
    ...mapActions([
      "shufflePreguntasActions",
      "setPreguntas",
      "enviarReporte",
      "clearPreguntas",
      "saveTestIncompleted",
      "loadPreguntasPorTemaExamen",
      "loadPreguntasPorTemas",
      "loadPreguntasPorTestsExamen",
      "loadPreguntasPorTestExamen",
    ]),
    change(change) {
      console.log("change " + change);
      if (this.pause) {
        return;
      }
      this.next(change);
    },
    isCorrect: function (respuesta) {
      if (this.userResponses[this.questionIndex] != null) {
        return (
          this.preguntas[this.questionIndex].respuestas[
            this.userResponses[this.questionIndex]
          ].correcta && this.userResponses[this.questionIndex] == respuesta
        );
      }
    },
    onClickOutside() {
      console.log("onClickOutside");

      this.textoReporte = "";
    },
    restart: function () {
      this.questionIndex = 0;
      this.userResponses = Array(this.preguntas.length).fill(null);
      this.timerCount = this.timerCountProp;
      this.blockTest = false;
      this.read = true;
      this.mostrarRespuestas = false;
      this.checkErrorsBool = false;
      this.model = [];
      this.blank = 0;
      this.fails = 0;
      this.scoreValue = 0;
    },
    checkErrors() {
      this.checkErrorsBool = true;

      console.log("checkErrors");
      this.questionIndex = 0;

      this.getCorrectAnswer();
      this.blockTest = true;
      this.read = true;
      this.mostrarRespuestas = true;
    },
    enviarReport() {
      const reporte = this.preguntas[this.questionIndex];
      console.log(reporte);
      reporte.usuario = this.usuario;
      reporte.textoReporte = this.textoReporte;
      this.enviarReporte(reporte);
      this.report = false;
      this.textoReporte = false;
    },
    getCorrectAnswer() {
      let contador = 0;
      this.preguntas[this.questionIndex].respuestas.forEach((element) => {
        if (element.correcta) {
          console.log("elemnt getCorrectAnswer");
          console.log(element);
          this.model = [contador];
        } else {
          contador++;
        }
      });
      console.log("this.model dentro GetCorrectAnswer ");
      console.log(this.model);
    },
    async initialize() {
      console.log("PARAMS tema");
      console.log(this.temaSelected);
      console.log("PARAMS TEST");
      console.log(this.testSelected);
      console.log("PARAMS TEMAS");
      console.log(this.temasSelected);
      console.log("PARAMS TESTS");
      console.log(this.testsSelected);
      console.log("numero preguntas");
      console.log(this.numeroPreguntas);

      if (this.resume) {
        this.timerCount = this.timerCountProp;
        this.questionIndex = this.questionIndexProps;
        this.userResponses = this.respuestasProps;
        this.setPreguntas(this.preguntasProps);
        console.log(this.userResponses);
        return;
      }

      if (
        this.testSelected == null &&
        this.temaSelected == null &&
        this.temasSelected == null &&
        this.testsSelected == null
      ) {
        this.$router.push({
          name: "home",
        });
        return;
      }

      this.clearPreguntas();

      // if (this.testSelected != null) {
      //   this.selected = this.testSelected;
      //   await this.loadPreguntasPorTestExamen(
      //     this.testSelected.numeroTest,
      //     this.numeroPreguntas
      //   );
      // }

      // if (this.temaSelected != null) {
      //   this.selected = this.temaSelected;
      //   await this.loadPreguntasPorTemaExamen(this.temaSelected.numeroTema);
      // }

      // if (this.temasSelected != null && this.temasSelected.length > 0) {
      //   await this.loadPreguntasPorTemas({
      //     temasSelected: this.temasSelected,
      //     numeroPreguntas: this.numeroPreguntas,
      //   });
      // }

      if (this.testsSelected != null && this.testsSelected.length > 0) {
        await this.loadPreguntasPorTestsExamen({
          testsSelected: this.testsSelected,
          numeroPreguntas: this.numeroPreguntas,
          porcentajesSelected: this.porcentajesSelected,
        });
      }

      console.log("preguntas cargadas");
      console.log(this.preguntas.length);

      // var preguntasNuevas = this.preguntas;

      // console.log("preguntas cambiadsa");

      // console.log(preguntasNuevas.length);
      // console.log(this.shuffle(preguntasNuevas));

      this.timerCount = this.timerCountProp;

      if (this.preguntas != null) {
        this.userResponses = Array(this.preguntas.length).fill(null);
      }
    },
    shuffle: function (array) {
      let i = array.length;
      while (i--) {
        const ri = Math.floor(Math.random() * (i + 1));
        [array[i], array[ri]] = [array[ri], array[i]];
      }
      return array;
    },
    selectOption: function (index) {
      if (this.blockTest) {
        return;
      }
      console.log("questionIndex");
      console.log(this.questionIndex);
      console.log(this.userResponses);
      // conjunto, key, value
      if (this.userResponses[this.questionIndex] == null) {
        this.$set(this.userResponses, this.questionIndex, index);
      } else {
        if (this.userResponses[this.questionIndex] != index) {
          this.$set(this.userResponses, this.questionIndex, index);
        } else {
          this.$set(this.userResponses, this.questionIndex, null);
        }
      }

      if (!this.checkErrorsBool) {
        console.log("this.checkErrorBool dentro de SelectOption");
        this.getCorrectAnswer();
        //this.model.push(index)

        this.blockTest = true;
        this.mostrarRespuestas = true;
        this.read = true;
      }

      /* if (index == 0){
         this.$set(this.userResponses, this.preguntas.respuestaA, index);

         }
         if (index == 1){
         this.$set(this.userResponses, this.preguntas.respuestaB, index);

         }
         if (index == 2){
         this.$set(this.userResponses, this.preguntas.respuestaC, index);

         }
         if (index == 0){
         this.$set(this.userResponses, this.preguntas.respuestaD, index);

         }
         */

      //console.log(this.userResponses);
    },
    next: function (questionIndex) {
      if (this.pause) {
        return;
      }
      console.log(
        "pregunta in next " +
          this.questionIndex +
          " de " +
          this.preguntas.length
      );
      if (this.questionIndex < this.preguntas.length) {
        // this.questionIndex++;

        if (this.questionIndex == this.preguntas.length) {
          return;
        }

        if (!this.checkErrorsBool) {
          console.log("this.checkErrorsBool next");
          console.log(this.checkErrorsBool);
          this.blockTest = false;
          this.mostrarRespuestas = false;
          this.read = true;
          this.model = [];
          if (this.userResponses[this.questionIndex] != null) {
            console.log("model antes" + this.model);
            this.mostrarRespuestas = true;
            this.getCorrectAnswer();
            this.blockTest = true;

            console.log("model despues" + this.model);
          } else {
            console.log("else in next antes de model vacio");
            this.model = [];
          }
        } else {
          this.blockTest = true;
          this.mostrarRespuestas = true;
          this.getCorrectAnswer();
        }
      }
    },

    prev: function () {
      if (this.pause) {
        return;
      }
      if (this.preguntas.length > 0 && this.questionIndex != 0) {
        this.questionIndex--;
        if (this.userResponses[this.questionIndex] != null) {
          this.blockTest = true;
          this.mostrarRespuestas = true;
          this.getCorrectAnswer();
        }
      }
    },
    // Return "true" count in userResponses
    save: function () {
      const data = {
        tipoExamen: 2,
        id: this.idTestIncompleted,
        tiempo: this.timerCount,
        respuestas: this.userResponses,
        questionIndex: this.questionIndex,
        preguntas: this.preguntas,
      };
      this.saveTestIncompleted(data);
    },
    score2: function () {
      this.questionIndex = this.preguntas.length;
    },

    score: function () {
      if (this.userResponses == null) {
        return;
      }

      console.log("Scoreeee");
      var score = 0;
      for (let i = 0; i < this.userResponses.length; i++) {
        if (
          typeof this.preguntas[i].respuestas[this.userResponses[i]] !==
            "undefined" &&
          this.preguntas[i].respuestas[this.userResponses[i]].correcta
        ) {
          this.scoreValue = this.scoreValue + 1;
        } else if (
          typeof this.preguntas[i].respuestas[this.userResponses[i]] !==
            "undefined" &&
          !this.preguntas[i].respuestas[this.userResponses[i]].correcta
        ) {
          this.fails = this.fails + 1;
        } else if (
          typeof this.preguntas[i].respuestas[this.userResponses[i]] ==
            "undefined" ||
          !this.userResponses[i] == null
        ) {
          this.blank = this.blank + 1;
        }
      }
      // return score;

      /* var score = 0;
      for (let i = 0; i < this.userResponses.length; i++) {
        var respuestaElegida = "error";
        console.log("this.userResponses[i]");
        console.log(this.userResponses[i]);
        switch (this.userResponses[i]) {
          case 0:
            respuestaElegida = "A";
            break;
          case 1:
            respuestaElegida = "B";
            break;
          case 2:
            respuestaElegida = "C";
            break;
          case 3:
            respuestaElegida = "D";
            break;
          default:
            break;
        }
        console.log("this.preguntas[i].respuestaCorrecta");
        console.log(this.preguntas[i].respuestaCorrecta);
        console.log("this.respuestaElegida");
        console.log(respuestaElegida);
        if (
          this.preguntas[i].respuestaCorrecta == respuestaElegida
          // esto esta mal....tengo que cambiar la A,B,C,D por el index

          // this.preguntas[i].responses[this.userResponses[i]].correct
        ) {
          score = score + 1;
        }
      }
      return score;
      */

      //return this.userResponses.filter(function(val) { return val }).length;
    },
  },
};
</script>
